import utils from './utils'
export function miniBack () {
    let str = utils.urlParam('switchTab')
    if (str && str.indexOf('1') >= 0) {
      wx.miniProgram.switchTab({url:'/pages/index/index'});
    } else {
      wx.miniProgram.navigateTo({url:'/pages/index/index'});
    }
}


// WEBPACK FOOTER //
// ./src/tools/miniback.js